var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.181641 9C1.12215 3.87976 5.60812 0 11.0003 0C16.3924 0 20.8784 3.87976 21.8189 9C20.8784 14.1202 16.3924 18 11.0003 18C5.60812 18 1.12215 14.1202 0.181641 9ZM11.0003 14C13.7617 14 16.0003 11.7614 16.0003 9C16.0003 6.23858 13.7617 4 11.0003 4C8.23884 4 6.00026 6.23858 6.00026 9C6.00026 11.7614 8.23884 14 11.0003 14ZM11.0003 12C9.3434 12 8.00026 10.6569 8.00026 9C8.00026 7.3431 9.3434 6 11.0003 6C12.6571 6 14.0003 7.3431 14.0003 9C14.0003 10.6569 12.6571 12 11.0003 12Z",
    fill: "#5D5189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFill);
export default __webpack_public_path__ + "static/media/eye-fill.bfcbe5459621bec6cbbe2588b7c9d1aa.svg";
export { ForwardRef as ReactComponent };